import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  CardTitle,
  Button,
  Label,
  CustomInput,
  Col,
  Form,
  FormGroup,
  Input,
  FormText,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { updateMachineMoreInfo } from "../../store/actions/machineActions";

class UpdateMachineMoreInfo extends Component {
  state = {
    id: "",
    location: "",
    task: "",
    status: "",
    dateOffRd: "",
    remarks: "",
    inputDisabled: true,
  };

  enableEditing = () => {
    this.setState({
      inputDisabled: false,

      location: this.props.machine.location,
      task: this.props.machine.task,
      status: this.props.machine.status,
      dateOffRd: this.props.machine.dateOffRd,
      remarks: this.props.machine.remarks,
      id: this.props.machine.id,
    });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleStatusSwitch = () => {
    if (this.state.status === "Off") {
      this.setState({
        status: "On",
      });
    } else {
      this.setState({
        status: "Off",
      });
    }
  };

  infoAlert = () => {
    this.setState({
      alert: (
        <SweetAlert
          title="Machine Unit Info"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          confirmBtnText="Ok"
          btnSize=""
        >
          {this.props.machine && this.props.machine.length !== 0 ? (
              <div style={{textAlign:'left'}}>
                  <p>{this.props.machine.UHANo ? (<span><b>UHA No : </b> <span>{this.props.machine.UHANo}</span></span>): (null)}</p>
                  <p>{this.props.machine.typeIdentity ? (<span><b>Type Identity : </b> <span>{this.props.machine.typeIdentity}</span></span>): (null)}</p>
                  <p>{this.props.machine.model ? (<span><b>Model : </b> <span>{this.props.machine.model}</span></span>): (null)}</p>
                  <p>{this.props.machine.name ? (<span><b>Name : </b> <span>{this.props.machine.name}</span></span>): (null)}</p>
                  <p>{this.props.machine.unit ? (<span><b>Unit : </b> <span>{this.props.machine.unit}</span></span>): (null)}</p>
              </div>
          ) : null}
        </SweetAlert>
      ),
    });
  };

  hideAlert = () => {
    this.setState({
      alert: null,
    });
  };


  handleSubmit = (e) => {
    e.preventDefault();
    console.log(this.state);
    this.props.updateMachineMoreInfo(this.state);
  };

  render() {
    const { machine } = this.props;
    return (
      <>
        {machine && machine.length !== 0 ? (
          <Card>
            <CardBody>
              <CardTitle>
                <h4 className="text-center">Update Machine More Details</h4>
              </CardTitle>
              {this.state.alert}
              <p>
                <b>UHA No :</b> {machine.UHANo}
              </p>
              <p>
                <b>Location :</b> {machine.location}
              </p>
              <p>
                <b>Task :</b> {machine.task}
              </p>
              <p>
                <b>Status :</b> {machine.status}
              </p>
              <p>
                <b>Date Off RD :</b> {machine.dateOffRd}
              </p>
              <p>
                <b>Remarks :</b> {machine.remarks}
              </p>

              <Button color="primary" outline block onClick={this.infoAlert} className="mb-4">
                View Machine Basic Info
              </Button>
              <hr/>

              <Button color="primary" block onClick={this.enableEditing} className="mt-4">
                Enable Edit
              </Button>
              <Form onSubmit={this.handleSubmit}>
                <FormGroup>
                  <FormText>Location</FormText>
                  <Input
                    required
                    type="text"
                    name="location"
                    id="location"
                    placeholder={machine.location}
                    onChange={this.handleChange}
                    disabled={this.state.inputDisabled}
                    value={this.state.location}
                  />
                </FormGroup>

                <FormGroup>
                  <FormText>Task</FormText>
                  <Input
                    required
                    type="text"
                    name="task"
                    id="task"
                    placeholder={machine.task}
                    onChange={this.handleChange}
                    disabled={this.state.inputDisabled}
                    value={this.state.task}
                  />
                </FormGroup>

                <FormGroup>
                  <FormText>Machine Status</FormText>
                  <CustomInput
                    type="switch"
                    id="status"
                    name="status"
                    label=""
                    onChange={this.handleStatusSwitch}
                    disabled={this.state.inputDisabled}
                    checked={this.state.status === "On" ? (true): (false)}
                  />
                  {!this.state.inputDisabled ? (<label>Status is {this.state.status}</label>):(null)}
                  
                </FormGroup>
                
                <FormGroup>
                <FormText>Date Off RD</FormText>
                {!this.state.inputDisabled ? (<label>Date is {this.state.dateOffRd}</label>):(null)}
                <Input
                  type="date"
                  name="dateOffRd"
                  id="dateOffRd"
                  placeholder="Select New Date"
                  onChange={this.handleChange}
                  disabled={this.state.inputDisabled}
                  // value={this.state.dateOffRd}
                />
              </FormGroup>

              <FormGroup>
              <FormText>Remarks</FormText>
                <Input
                  type="textarea"
                  name="remarks"
                  id="remarks"
                  placeholder={machine.remarks}
                  onChange={this.handleChange}
                  disabled={this.state.inputDisabled}
                  value={this.state.remarks}
                />
              </FormGroup>

                <FormGroup>
                  <Button
                    color="primary"
                    block
                    disabled={this.state.inputDisabled}
                  >
                    Update
                  </Button>
                </FormGroup>
              </Form>
            </CardBody>
          </Card>
        ) : null}
      </>
    );
  }
}

// const mapStateToProps = (state) => {
//   return {
//     profile: state.firebase.profile,
//   };
// };

const mapDispatchToProps = (dispatch) => {
  return {
    updateMachineMoreInfo: (machine) => dispatch(updateMachineMoreInfo(machine)),
  };
};

export default compose(connect(null, mapDispatchToProps))(
  UpdateMachineMoreInfo
);
